import { useRef, useEffect } from 'react'

export function BackgroundMusic() {
  const audioRef = useRef<HTMLAudioElement>(null)
  
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = 0.5
      audioRef.current.loop = true
      
      // 尝试自动播放
      const playAudio = () => {
        if (audioRef.current) {
          audioRef.current.play().catch(() => {
            // 如果自动播放被阻止，等待用户交互后再播放
            const handleInteraction = () => {
              audioRef.current?.play()
              document.removeEventListener('click', handleInteraction)
              document.removeEventListener('touchstart', handleInteraction)
              document.removeEventListener('keydown', handleInteraction)
            }
            document.addEventListener('click', handleInteraction)
            document.addEventListener('touchstart', handleInteraction)
            document.addEventListener('keydown', handleInteraction)
          })
        }
      }
      
      playAudio()
    }
  }, [])
  
  return (
    <audio
      ref={audioRef}
      src="/music/汪苏泷 - 小星星.mp3"
      preload="auto"
      loop
      autoPlay
    />
  )
}